var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2",style:(_vm.toast.visible ? 'top: 100px' : 'top: -100px'),attrs:{"id":"app-toast"}},[_vm._v(" "+_vm._s(_vm.toast.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }